var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpCenter"},[_c('HelpCenterSearch'),_c('div',{staticClass:"help_nav"},[_c('ProblemComponents',{attrs:{"infoObj":_vm.infoObj}}),_c('treeIndex',{attrs:{"treeData":_vm.treeData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }